import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

interface Props {
  children: ReactNode;
}

export default function AdminGuard({ children }: Props) {
  const token = Cookies.get('admin_access_token');

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
